





























































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
// @ts-ignore
import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 500, interval: 0})
// @ts-ignore
import VueDragResize from "vue-drag-resize";
import { BaseSheet, Student, PageItem } from "../../modules/teacher/LessonKyouzaiList"

export interface Data {
  lesson_class_id: string
  base_sheet: BaseSheet
  students: Student[]
  selectedStudent: Student
  selectedPageIdx: number
  selectedPageItem: PageItem
  base64_answer_images: string[]
  windowHeight: number
  fields: any[]
  errors: string[]
  inputScale: number
  cut_margin: number
}

export default defineComponent({
  directives: {
    longclick: longClickInstance
  },
  components: {
    "alert-area": AlertArea,
    "vue-drag-resize": VueDragResize,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      lesson_class_id: "",
      base_sheet: null,
      students: [],
      selectedStudent: null,
      selectedPageIdx: 0,
      selectedPageItem: null,
      base64_answer_images: [],
      windowHeight: 0,
      fields: [
        {key: "student_code", label: "生徒CD", sortable: true, class: 'text-center b-table-th-td min-width-column'},
        {key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td max-width-column'},
        {key: "images", label: "画像", sortable: true, class: 'text-center b-table-th-td min-width-column'},
      ],
      errors: [],
      inputScale: 50,
      cut_margin: null,
    });

    /************************************************************
     * スライダーの倍率を画像倍率に変換
     ************************************************************/

    const scale = computed((): number => {
      return Number(state.inputScale) / 100;
    });

    /************************************************************
     * 全体画像のCSS
     ************************************************************/
    const imageStyle = computed((): object => {
      let style: any = {};
      style["width"] = `${state.base_sheet.correct_image_size[0] * scale.value}px`;
      style["height"] = `${state.base_sheet.correct_image_size[1] * scale.value}px`;  
      return style;
    });

    /************************************************************
     * 全体画像の親DivのCSS
     ************************************************************/
    const imageWrapStyle = computed((): object => {
      let style: any = {};
      style["width"] = `${state.base_sheet.correct_image_size[0] * scale.value}px`;
      style["height"] = `${state.base_sheet.correct_image_size[1] * scale.value}px`;  
      return style;
    });

    /************************************************************
     * 画面サイズに合わせてレイアウト整形
     ************************************************************/
    
    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      const imageArea = document.getElementById("image-area");

      if(tableArea != null && imageArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop) + "px";
        imageArea.style.height = (winH - imageArea.offsetTop) + "px";
      }
    };

    /************************************************************
     * 表示画像変更
     ************************************************************/

    const changeCurrent = async (student: Student, pageIdx: number) => {
      
      // 解答情報を取得前の場合はAPIで取得
      if(!student.pageItems){
        await getAnswerData(student);
      }

      state.selectedStudent = student;
      state.selectedPageIdx = pageIdx;
      if(state.selectedStudent.pageItems && state.selectedStudent.pageItems.length >= state.selectedPageIdx){
        state.selectedPageItem = state.selectedStudent.pageItems[state.selectedPageIdx];
      }else{
        state.selectedPageItem = null;
      }
    }

    /************************************************************
     * 生徒の解答データ取得
     ************************************************************/

    const getAnswerData = async (student: Student) => {
      await http.get(`/api/teacher/lesson_kyouzai_list/get_answer_data?student_sheet_id=${student.student_sheet_id}&base_sheet_id=${state.base_sheet.id}`).then(response => {
        const pageItems: PageItem[] = []
        for(let i = 0; i < state.base_sheet.page_count; i++){
          const pageItem = new PageItem(i + 1, response.data.base_sheet_fields, state.base_sheet.correct_image_size[0], state.base_sheet.correct_image_size[1]);
          pageItems.push(pageItem);
        }
        student.pageItems = pageItems;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * keyupショートカット
     ************************************************************/


    const keyUp = (e: KeyboardEvent): void => {

      if(!state.students){
        return;
      }

      if(!state.selectedStudent){
        changeCurrent(state.students[0], 0);
      }

      const idx = state.students.indexOf(state.selectedStudent);

      if (e.key == "ArrowDown") {
        e.preventDefault();
        if(state.students.length > idx + 1){
          changeCurrent(state.students[idx + 1], state.selectedPageIdx);
        }
      }

      if (e.key == "ArrowUp") {
        e.preventDefault();
        if(idx > 0){
          changeCurrent(state.students[idx - 1], state.selectedPageIdx);
        }
      }

      if (e.key == "ArrowLeft") {
        e.preventDefault();
        if(state.selectedPageIdx > 0){
          changeCurrent(state.selectedStudent, state.selectedPageIdx - 1);
        }
      }
      
      if (e.key == "ArrowRight") {
        e.preventDefault();
        if(state.base_sheet.page_count > state.selectedPageIdx + 1){
          changeCurrent(state.selectedStudent, state.selectedPageIdx + 1);
        }
      }
    }
    
    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      state.lesson_class_id = context.root.$route.params.lesson_class_id;

      await http.get(`/api/teacher/lesson_kyouzai_list?lesson_class_id=${state.lesson_class_id}`).then(response => {
        state.base_sheet = response.data.base_sheet;
        state.students = response.data.students.map((x: any) => new Student(x));
        state.base64_answer_images = response.data.base64_answer_images;
        state.cut_margin = response.data.cut_margin;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。一覧に戻ります。`);
        }
        context.root.$store.dispatch("goBaseSheetList");
      });
      
      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("keyup", keyUp);

      changeCurrent(state.students[0], 0);
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keyup", keyUp);
    });

    return {
      ...toRefs(state),
      scale,
      changeCurrent,
      imageStyle,
      imageWrapStyle,
    };
  }
})
